import { useCreatePortfolioMutation } from 'hooks/mutations/Rewards/useCreatePortfolioMutation'
import { useRewardsTracking } from 'pages/Rewards/hooks/useRewardsTracking'
import { BaseErrorResponse } from 'types/beneficiaries'
import { Portfolio } from 'types/rewards'

export const useCreatePortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: Portfolio) => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()
  const { mutateAsync: createPortfolio, isPending: isCreatingPortfolioPending } =
    useCreatePortfolioMutation()

  const handleCreatePortfolio = (earningProductId: string) => {
    return createPortfolio(
      { earningProductId },
      {
        onSuccess: (data: Portfolio) => {
          trackSuccess('createPortfolio', { currency: data.currency })
          onSuccess?.(data)
        },
        onError: (error: BaseErrorResponse) => {
          trackError('createPortfolio', error, { productId: earningProductId })
          onError?.(error)
        },
      }
    )
  }

  return {
    createPortfolio: handleCreatePortfolio,
    isCreatingPortfolioPending,
  }
}
